import { routing } from "./routing";

export const DEFAULT_LOCALE = routing.defaultLocale.toLowerCase();

export const SUPPORTED_LOCALES = routing.locales.map((locale) =>
  locale.toLowerCase(),
);

export const LOCALE_COOKIE_NAME = "NEXT_LOCALE";
export const LOCALE_COOKIE_DAYS = 365;

/**
 * Locales that must never be served directly.
 * Requests with an aliased locale are redirected to the target locale.
 * Example: /en/about -> /en-us/about
 */
export const LOCALE_ALIASES: Record<string, string> = {
  en: "en-us",
};
